export async function cds(url, settings = {}) {

    // token getir
    var token = localStorage.getItem('token');
    
    // options oluştur
    var options = {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    };

    // post mu?
    if (settings.hasOwnProperty('method') && settings.method === 'POST') {

        // null değerleri sil
        settings.body = Object.keys(settings.body || {})
            .filter(key => settings.body[key] !== null)
            .reduce((acc, key) => {
                acc[key] = settings.body[key];
                return acc;
            }, {});

        var body = Object.keys(settings.body || {})
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(settings.body[key]))
            .join('&');

        options.method = 'POST';
        options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        options.body = body;

    }

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + '/' + url, options);

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const json = await response.json();
        return json;
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
    
}

export function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
}